// eslint-disable-next-line import/prefer-default-export
export const LoggingEvents = {
  CardRenderError: 'CardRenderError',
  CardSubmit: 'CardSubmit',
  TechnicalProblemOccurred: 'TechnicalProblemOccurred',
  WebviewSDKNotInitialized: 'WebviewSDKNotInitialized',
  PaymentWidgetLogs: 'PaymentWidgetLogs',
  FlightChangeLogs: 'FlightChangeLogs',
  RefundTrackerWidgetLogs: 'RefundTrackerWidgetLogs',
  DataCollectorLogs: 'DataCollectorLogs',
  DeclarativeCardLogs: 'DeclarativeCardLogs',
  TimeTillCreateConversation: 'TimeTillCreateConversation',
  TimeToRenderVAC: 'TimeToRenderVAC',
};
